import { render, staticRenderFns } from "./DrmPurgeNotice.vue?vue&type=template&id=c9be608c&scoped=true"
import script from "./DrmPurgeNotice.vue?vue&type=script&lang=js"
export * from "./DrmPurgeNotice.vue?vue&type=script&lang=js"
import style0 from "./DrmPurgeNotice.vue?vue&type=style&index=0&id=c9be608c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9be608c",
  null
  
)

export default component.exports